import { getUser } from "api/user/user";

export const queryUser = ({ slug, user }) => ({
	queryKey: ["user", slug, user?.uid],
	queryFn: async () => getUser({ authToken: user?.accessToken, slug }),
});
